import { Utils } from '../utils'

export class ClassRegistry<T> {
  private _classRegistry: Map<string, {new(): T}> = new Map<string, {new(): T}>()

  public constructor(
    private _utils: Utils,
    classes: Array<{new(): T}>,
    private suffix: string = ''
  ) {
    classes.forEach((klass) => this._classRegistry.set(this._getClassName(klass.name), klass))
  }

  public get(className: string): {new(): T} {
    const klass = this._classRegistry.get(this._getClassName(className))

    if (! klass) {
      throw new Error((`${className} has not been registered`))
    }

    return klass
  }

  private _getClassName(className) {
    const suffixRegex = new RegExp(`(.*)${this.suffix}$`, 'i')
    return this._utils.pascalCase(`${className.replace(suffixRegex, '$1')}${this.suffix}`)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/class-registry/class-registry.ts